/**
 * CDT Data Table — Divi 5 Module Bundle Entry Point
 *
 * This file is the Webpack entry point. It registers all CDT modules
 * with the Divi 5 module library using the WordPress hooks system.
 *
 * The `registerModule` function from @divi/module-library hooks into
 * Divi's init cycle so the module appears natively in the Visual Builder.
 */

import { addAction } from '@wordpress/hooks';
import { registerModule } from '@divi/module-library';

import { cdtDataTableModule } from './CdtDataTableEdit';

/**
 * Register CDT modules when Divi's module library is ready.
 * The action name 'divi.moduleLibrary.registerModuleLibraryStore.done'
 * fires after all Divi modules are loaded but before the VB initialises.
 */
addAction(
    'divi.moduleLibrary.registerModuleLibraryStore.done',
    'cdt/data-table',
    () => {
        registerModule( cdtDataTableModule.name, cdtDataTableModule );
    }
);
